import { useState } from "react";
import classes from "./InputCheckbox.module.css";

export function InputCheckbox({ label, checked, onChange, disabled }) {
  const handleChange = () => {
    if (onChange) {
      onChange(label);
    }
  };

  return (
    <div className={classes.container}>
      <input
        type="checkbox"
        id={label}
        className={classes.radio}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <label htmlFor={label} className={classes.label}>
        <span className={classes.radioBox}></span>
        {label}
      </label>
    </div>
  );
}
